import moment from 'moment';
import React, { useState } from 'react';
import useSWR from 'swr';
import { z } from 'zod';

import Tab from '@/components/UI/mobile/Tab';
import { getAxiosWithAuth } from '@/lib/axios';
import useUser from '@/lib/hooks/useUser';
import { Fix, fixSchema } from '@/types/database/fix';

import { AddFixButton, FixItemList, FixListWrapper } from './styles';
import { statusColors } from '../../helpers';
import FixItem from './FixItem';

const FixList: React.FC<{
  addFix: () => void;
  checkMore: (fix: Fix) => void;
  checkProgress: (fix: Fix) => void;
  checkMessage: (fix: Fix) => void;
}> = ({ addFix, checkMore, checkProgress, checkMessage }) => {
  const [currentTab, setCurrentTab] = useState(0);

  const { data: user } = useUser();

  let fetchUrl = '/ezcon/api/fixes';

  const householdNumber = user?.householdNumbers?.[0];

  if (householdNumber) {
    fetchUrl += `?householdNumber=${householdNumber}`;
  }

  if (currentTab === 1) {
    fetchUrl += `&status[]=已處理`;
  }

  const { data: fixList } = useSWR(fetchUrl, async (url: string) => {
    const axios = getAxiosWithAuth();
    const { data } = await axios.get(url);
    const result = z.array(fixSchema).safeParse(data);
    if (result.success) {
      return result.data;
    }
    throw new Error('Invalid data');
  });

  return (
    <FixListWrapper>
      <AddFixButton disableRipple onClick={addFix}>
        我要報修
      </AddFixButton>
      <Tab
        options={['報修進度', '歷史資料']}
        value={currentTab}
        onChange={setCurrentTab}
        customStyle={{ marginBottom: '1rem' }}
      />
      <FixItemList>
        {fixList?.map((fix) => (
          <FixItem
            key={fix._id + Math.random()}
            fixData={{
              status: {
                color: statusColors[fix.status],
                text: fix.status,
              },
              createdTime: moment(fix.createdTime).format('YYYY-MM-DD HH:mm'),
              serialNumber: fix.serialNumber,
              area: fix.category.name,
              title: fix.title,
              content: fix.content,
            }}
            onCheckMore={() => checkMore(fix)}
            onCheckMessage={() => checkMessage(fix)}
            onCheckProgress={() => checkProgress(fix)}
          />
        ))}
      </FixItemList>
    </FixListWrapper>
  );
};

export default FixList;
